import { gql } from '@apollo/client'

export const CREATE_AVAILABILITY = gql`
  mutation($data: CreateAvailabilityInput!) {
    createAvailability(data: $data) 
  }
`

export const GET_AVAILABILITIES = gql`
  query($data: AvailabilitiesInput!) {
    availabilities(data: $data) {
      id
      startDate
      endDate
      caregiverId
      sfCaregiverId
      override
      availabilityTimes {
        id
        startTime
        endTime
        day
      }
    }
  }
`

export const UPDATE_AVAILABILITY = gql`
  mutation($data: UpdateAvailabilityDataInput!) {
    updateAvailability(data: $data) 
  }
`

export const DELETE_AVAILABILITY = gql`
  mutation($id: ID!) {
    deleteAvailability(id: $id) 
  }
`
export const CREATE_OVERRIDE_AVAILABILITY = gql`
  mutation($data: CreateAvailabilityInput!) {
    createOverrideAvailability(data: $data) 
  }
`

export const DELETE_OVERRIDE_AVAILABILITY = gql`
  mutation($id: ID!) {
    deleteOverrideAvailability(id: $id) 
  }
`

export const GET_AVAILABILITIES_BY_PATIENT_ID = gql`
  query availabilitiesByPatientId($data: AvailabilitiesByPatientIdInput!) {
    availabilitiesByPatientId(data: $data) {
      id
      startDate
      endDate
      caregiverId
      sfCaregiverId
      override
      availabilityTimes {
        id
        startTime
        endTime
        day
      }
    }
  }
`
